import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import BesiktasIntro from "../components/ServiceRegions/İntros/BesiktasIntro";
import DynamicImage from "../components/DynamicImage";


const BesiktasPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      <DynamicImage />
      {/* <AboutSection/> */}
      <BesiktasIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};
export default BesiktasPage;